import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../mfe/MfeLoader";
import { getAgentGatewayHostConfig } from "../config/agentGatewayHostConfig";
import { useHostNavigate } from "../hooks/useHostNavigate";
import { usePermissionState } from "../contexts/PermissionStateContext";

export const Route = createFileRoute("/agent-gateway/$")({
  component: AgentGatewayMfePage,
});

function AgentGatewayMfePage() {
  const onNavigate = useHostNavigate();
  const permissionState = usePermissionState();
  return (
    <MfeLoader
      name="agent-gateway"
      props={{
        hostConfig: getAgentGatewayHostConfig(onNavigate, permissionState),
      }}
    />
  );
}
